module.exports = __webpack_public_path__ + "img/header-weddingRingsNaturalBeige@2x.83a0e25.jpg";